<template>
  <div class="wrapper">
    <div class="page-header">
      <div class="page-ribbon">
        <div class="path">
          <img
            src="@/assets/admin-icon/reports-active.svg"
          /><pathViewer></pathViewer>
        </div>
        <div class="ribbon-options"></div>
      </div>
      <div class="page-options" v-if="false"></div>
    </div>
    <div class="page-body">
      <div class="tabs-widget">
        <div class="profile-widget">
          <img
            v-if="user.company_info.company_logo"
            :src="$fullUrl('images/profiles/' + user.company_info.company_logo)"
          />
          <img v-else src="@/assets/icons/logo_avatar.svg" />
          <h2 class="company-name">
            {{ user.company_info.company_name | validate }}
          </h2>
          <p>{{ user.company_info.address | validate }}</p>
        </div>
        <div class="tabs-links">
          <div
            class="tab"
            style="justify-content: flex-start"
            :class="{ active: tab_type == 'overview' }"
            @click="switchTab('overview')"
          >
            <span class="name">Overview</span>
            <span class="icon">
              <img
                v-if="tab_type == 'public'"
                src="@/assets/icons/consultant-profile-icons/general-infos-active.svg"
              />
              <img
                v-else
                src="@/assets/icons/consultant-profile-icons/general-infos.svg"
              />
            </span>
          </div>
          <div
            class="tab"
            :class="{
              active: tab_type == 'tasks',
            }"
            @click="switchTab('tasks')"
          >
            <span class="name">Tasks</span>
            <span class="icon">
              <img
                v-if="tab_type == 'consultants'"
                src="@/assets/icons/consultant-profile-icons/consultants-active.svg"
              />
              <img
                v-else
                src="@/assets/icons/consultant-profile-icons/consultants.svg"
              />
            </span>
          </div>
          <div
            class="tab"
            :class="{ active: tab_type == 'leads' }"
            @click="switchTab('leads')"
          >
            <span class="name">Leads</span>
            <span class="icon">
              <img
                v-if="tab_type == 'project'"
                src="@/assets/icons/consultant-profile-icons/projects-active.svg"
              />
              <img
                v-else
                src="@/assets/icons/consultant-profile-icons/projects.svg"
              />
            </span>
          </div>
          <div
            class="tab"
            :class="{ active: tab_type == 'candidates' }"
            @click="switchTab('candidates')"
          >
            <span class="name">Candidates</span>
            <span class="icon">
              <img
                v-if="tab_type == 'skills'"
                src="@/assets/icons/consultant-profile-icons/skills-active.svg"
              />
              <img
                v-else
                src="@/assets/icons/consultant-profile-icons/skills.svg"
              />
            </span>
          </div>
          <div
            class="tab"
            :class="{
              active: tab_type == 'accounts',
            }"
            @click="switchTab('accounts')"
          >
            <span class="name">Accounts</span>
            <span class="icon">
              <img
                v-if="tab_type == 'skills'"
                src="@/assets/icons/consultant-profile-icons/skills-active.svg"
              />
              <img
                v-else
                src="@/assets/icons/consultant-profile-icons/skills.svg"
              />
            </span>
          </div>

          <div
            class="tab"
            :class="{
              active: tab_type == 'organisation',
            }"
            @click="switchTab('organisation')"
          >
            <span class="name">Organisation</span>
            <span class="icon">
              <img
                v-if="tab_type == 'skills'"
                src="@/assets/icons/consultant-profile-icons/skills-active.svg"
              />
              <img
                v-else
                src="@/assets/icons/consultant-profile-icons/skills.svg"
              />
            </span>
          </div>
        </div>
      </div>
      <div class="tab-body">
        <Overview v-if="tab_type == 'overview'"></Overview>
        <Tasks v-if="tab_type == 'tasks'"></Tasks>
        <Leads v-if="tab_type == 'leads'"></Leads>
        <Candidates v-if="tab_type == 'candidates'"></Candidates>
        <Accounts v-if="tab_type == 'accounts'"></Accounts>
        <Organization v-if="tab_type == 'organisation'"></Organization>
      </div>
    </div>
  </div>
</template>
<script>
import Overview from "@/views/Reports/Overview.vue";
import Tasks from "@/views/Reports/Tasks.vue";
import Leads from "@/views/Reports/Leads.vue";
import Candidates from "@/views/Reports/Candidates.vue";
import Accounts from "@/views/Reports/Accounts.vue";
import Organization from "@/views/Reports/Organization.vue";
export default {
  name: "Reports",
  components: {
    Overview,
    Tasks,
    Leads,
    Candidates,
    Accounts,
    Organization,
  },
  data() {
    return {
      tab_type: "overview",
      user: {
        company_info: {},
        manager_info: {},
        manager_profile: {},
      },
    };
  },
  watch: {
    "$route.params.type"(val) {
      let vm = this;
      vm.tab_type = val;
    },
  },
  methods: {
    switchTab(type) {
      let vm = this;
      let path = [
        {
          label: "Reports",
        },
        {
          label: type,
          active: true,
        },
      ];
      vm.$store.commit("SET_PATH", path);
      vm.$router
        .push({ name: "reports", params: { type: type } })
        .catch((error) => {});
    },
  },
  computed: {},
  mounted() {
    let vm = this;
    let path = [
      {
        label: "Reports",
      },
    ];
    vm.$store.commit("SET_PATH", path);
    vm.$store
      .dispatch("GET_ME_USER_COMPANY")
      .then((responce) => {
        vm.user = responce.data;
      })
      .catch((error) => {});
    if (vm.$route.params.type) {
      vm.tab_type = vm.$route.params.type;
    }
  },
  created() {},
};
</script>
<style lang="scss" scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ebebeb;
  .page-header {
    background: #dfdfdf;
    .page-ribbon {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 41px;
      padding: 0px 15px;
      background: #fff;
      .path {
        color: #0884af;
        font-size: 13px;
        display: flex;
        align-items: center;
        img {
          width: 20px;
          margin-right: 6px;
        }
        span {
          margin-top: 4px;
        }
      }
      .ribbon-options {
        display: flex;
        align-items: center;
        .btn-search {
          border: none;
          background: transparent;
          img {
            width: 13px;
            object-fit: contain;
          }
        }
        .btn-customer-user {
          background: transparent;
          border: none;
          display: flex;
          align-items: center;
          .profile-logo {
            width: 15px;
            height: 15px;
            object-fit: cover;
            border-radius: 50%;
            margin-right: 5px;
          }
          span {
            margin-right: 5px;
          }
        }
      }
    }
    .page-options {
      display: flex;
      padding: 6px 15px;
      background: #d0d0d0;
      min-height: 50px;
      .btn-option {
        background: transparent;
        color: #000;
        border: none;
        padding: 10px 30px;
        border-radius: 5px;
        cursor: pointer;
        outline: none;
        &.active {
          background: #fff;
          color: #0884af;
        }
      }
    }
  }

  .page-body {
    height: calc(100% - 40px);
    width: 100%;
    display: grid;
    overflow-x: hidden;
    overflow: hidden;
    position: relative;
    grid-template-columns: 200px calc(99% - 200px);
    padding: 0px 0px;
    padding-left: 10px;
    padding-top: 10px;
    grid-column-gap: 8px;
    @media (min-width: 300px) and (max-width: 630px) {
      grid-template-columns: 100%;
      padding-left: 0px;
    }
    .tabs-widget {
      display: flex;
      flex-direction: column;
      background: #fff;
      width: 100%;
      border-bottom: 1px solid #efefef;
      border-radius: 5px;

      .profile-widget {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 20px;
        margin-bottom: 20px;
        @media (min-width: 300px) and (max-width: 630px) {
          display: none;
        }
        img {
          width: 70px;
          height: 70px;
          border-radius: 50%;
          color: #0884af;
          object-fit: cover;
        }
        h2 {
          margin: 0px;
          font-size: 20px;
          margin: 10px 0px;
          color: #0884af;
        }
        p {
          color: #707070;
          margin: 0px;
          text-align: center;
        }
      }
      .tabs-links {
        display: flex;
        flex-direction: column;
        @media (min-width: 300px) and (max-width: 630px) {
          flex-direction: row;
          justify-content: space-between;
        }
        .tab {
          cursor: pointer;
          height: 50px;
          display: flex;
          align-items: center;
          padding: 0px 15px;
          @media (min-width: 300px) and (max-width: 630px) {
            font-size: 11px;
          }
          .name {
            display: block;
            font-size: 13px;
            @media (min-width: 300px) and (max-width: 630px) {
              display: none;
            }
          }
          .icon {
            display: none;
            background: #dedede;
            height: 40px;
            width: 40px;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            @media (min-width: 300px) and (max-width: 630px) {
              display: flex;
            }
            img {
              width: 22.9px;
            }
          }
        }
        .tab.active {
          color: #fff;
          background: #0884af;
          font-weight: 800;
          @media (min-width: 300px) and (max-width: 630px) {
            background: #fff;
          }
          .icon {
            background: #1890a9;
          }
        }
        .tab:hover {
          color: #fff;
          background: #0884af;
          @media (min-width: 300px) and (max-width: 630px) {
            background: #fff;
          }
        }
      }
    }
    .tab-body {
      width: 100%;
      padding-bottom: 0px;
      padding-left: 0px;
      padding-right: 8px;
      padding-top: 0px;
      height: calc(100vh - 50px);
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
